import { component } from 'picoapp';
import { clear } from 'utils/node';

export default component((node) => {
  const { productId, baseUrl, limit } = node.dataset;

  const initRecommendations = () => {
    const request = new XMLHttpRequest();

    request.open('GET', `${baseUrl}?section_id=template-product-recommendations&product_id=${productId}&limit=${limit}`);
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        const container = document.createElement('div');
        container.innerHTML = request.response;

        clear(node);
        node.insertAdjacentHTML(
          'beforeend',
          container.querySelector('[data-component]').innerHTML,
        );
      }
    };
    request.send();
  };

  initRecommendations();
});
